import React from 'react'
import MorningIcon from '../../../../../Assets/Images/icons/newIcons/morningIcon'
import LunchIcon from '../../../../../Assets/Images/icons/newIcons/lunchIcon'
import AfternoonIcon from '../../../../../Assets/Images/icons/newIcons/afternoonIcon'
import { WEATHER_CONDITIONS } from '../../../../../Utils/Weather'

export const headers = [
  {
    label: 'Dates',
    xs: 5,
    align: 'flex-start',
    key: 'date',
  },
  {
    label: 'Morning',
    xs: 1,
    icon: <MorningIcon />,
    key: 'morningMissions',
  },
  {
    label: 'Lunch',
    xs: 1,
    icon: <LunchIcon />,
    key: 'lunchMissions',
  },
  {
    label: 'Afternoon',
    xs: 1,
    icon: <AfternoonIcon />,
    key: 'afternoonMissions',
  },
  {
    label: 'Details',
    xs: 1,
    key: 'details',
  },
]

export const GOOD_WEATHER_CONDITIONS = [
  WEATHER_CONDITIONS.CLEAR,
  WEATHER_CONDITIONS.PARTIALLY_CLOUDY,
  WEATHER_CONDITIONS.OVERCAST,
]
